<div class="profile-container">
    <div class="">
        <div class="profile-content">
  
            <div class="personal-details" *ngIf="!isEdit">
                <h4 class="personal-details-title">Payment Term List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Term Name</th>
                      <th scope="col">Term Value</th>
                      <th scope="col">Term Type</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let term of paymentTermData | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber+1,
                      totalItems: totalRecords
                    };let i = index">
                      <th scope="col">{{term.termName}}</th>
                      <th scope="col">{{term.termValue}}</th>
                      <th scope="col">{{term.termType}}</th>
                      <th scope="col">
                        <i class="bi bi-pencil-square" (click)="getPaymentTermById(term.paymentTermId)" data-toggle="modal" data-target="#exampleModalView"></i>
                      </th>
                    </tr>    
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="paymentTermData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
            </div>


            <div class="personal-details" *ngIf="isEdit">
                <h4 class="personal-details-title">Edit Payment Term</h4>
                <div [formGroup]="paymentTermForm" class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Term Name <span class="required">*</span></label>
                            <input class="form-control" formControlName="termName" type="text">
                        </div>
                    </div>
    
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Term Value <span class="required">*</span></label>
                            <input class="form-control" formControlName="termValue" type="text">
                        </div>
                    </div>
    
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Term Type <span class="required">*</span></label>
                            <select class="form-control" formControlName="termType">
                              <option *ngFor="let type of termTypes" [value]="type.value">
                                {{ type.viewValue }}
                              </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-12 add-button">
                        <button class="btn btn-secondary" (click)="closeEdit()">Cancel</button>

                        <button type="button" (click)="editPaymentTerm()" class="btn btn-primary">Edit Payment Term</button>

                    </div>
                </div> 
            </div> 
  
        </div>
    </div>
</div>